import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { colors } from '../theme';
import ApartmentIcon from '@mui/icons-material/Apartment';
import HomeIcon from '@mui/icons-material/Home';
import HotelIcon from '@mui/icons-material/Hotel';
import BusinessIcon from '@mui/icons-material/Business';
import FactoryIcon from '@mui/icons-material/Factory';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

function ClientsSection() {
  const clientTypes = [
    {
      title: 'Public Housing',
      description: 'HDB & BTO developments',
      icon: <ApartmentIcon sx={{ fontSize: 60 }} />,
      color: colors.green,
    },
    {
      title: 'Condominiums',
      description: 'Private residential estates',
      icon: <HomeIcon sx={{ fontSize: 60 }} />,
      color: colors.yellow,
    },
    {
      title: 'Hotels & Resorts',
      description: 'Hospitality sector',
      icon: <HotelIcon sx={{ fontSize: 60 }} />,
      color: colors.green,
    },
    {
      title: 'Commercial',
      description: 'Office buildings & retail',
      icon: <BusinessIcon sx={{ fontSize: 60 }} />,
      color: colors.yellow,
    },
    {
      title: 'Industrial',
      description: 'Warehouses & factories',
      icon: <FactoryIcon sx={{ fontSize: 60 }} />,
      color: colors.green,
    },
    {
      title: 'Fleet Operators',
      description: 'Commercial vehicle fleets',
      icon: <LocalShippingIcon sx={{ fontSize: 60 }} />,
      color: colors.yellow,
    },
  ];

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: colors.white,
      }}
    >
      <Container maxWidth="lg">
        {/* Section Header */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2rem', md: '2.75rem' },
              fontWeight: 800,
              mb: 2,
              color: colors.black,
            }}
          >
            Our{' '}
            <Box component="span" sx={{ color: colors.green }}>
              Clientele
            </Box>
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: '#666',
              maxWidth: '700px',
              mx: 'auto',
              fontSize: { xs: '1rem', md: '1.2rem' },
            }}
          >
            Trusted by diverse sectors across Singapore
          </Typography>
        </Box>

        {/* Client Types Grid */}
        <Grid container spacing={4}>
          {clientTypes.map((client, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Paper
                elevation={0}
                sx={{
                  height: '100%',
                  borderRadius: 4,
                  overflow: 'hidden',
                  border: '1px solid #e0e0e0',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  '&:hover': {
                    transform: 'translateY(-12px)',
                    boxShadow: `0 16px 48px ${client.color}30`,
                    border: `2px solid ${client.color}`,
                  },
                }}
              >
                {/* Image/Icon Area */}
                <Box
                  sx={{
                    height: 200,
                    bgcolor: `${client.color}10`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    overflow: 'hidden',
                  }}
                >
                  {/* Background Icon */}
                  <Box
                    sx={{
                      position: 'absolute',
                      color: client.color,
                      opacity: 0.15,
                      transform: 'scale(2)',
                    }}
                  >
                    {client.icon}
                  </Box>

                  {/* Icon display */}
                  <Box
                    sx={{
                      position: 'relative',
                      zIndex: 1,
                      color: client.color,
                    }}
                  >
                    {client.icon}
                  </Box>
                </Box>

                {/* Content */}
                <Box sx={{ p: 3 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      mb: 1,
                      color: colors.black,
                      fontSize: { xs: '1.2rem', md: '1.4rem' },
                    }}
                  >
                    {client.title}
                  </Typography>
                  <Typography
                    sx={{
                      color: '#666',
                      fontSize: '0.95rem',
                    }}
                  >
                    {client.description}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Bottom CTA */}
        <Box
          sx={{
            mt: 8,
            p: 4,
            borderRadius: 4,
            background: `linear-gradient(135deg, ${colors.green}15 0%, ${colors.yellow}15 100%)`,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: colors.black,
              mb: 1,
              fontSize: { xs: '1.2rem', md: '1.5rem' },
            }}
          >
            Whatever Your Property Type
          </Typography>
          <Typography
            sx={{
              color: '#666',
              fontSize: '1rem',
              maxWidth: '600px',
              mx: 'auto',
            }}
          >
            We design, install, and manage EV charging solutions tailored to your specific needs
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default ClientsSection;
